<div class="simple-dialog">
  <div mat-dialog-title class="dialog-header">
    <div class="dialog-title">
      <mat-icon>description</mat-icon>
      <h2>{{ (data.isEditingNew ? 'ppwr.docProfiles.dialog.addTitle' : 'ppwr.docProfiles.dialog.editTitle') | transloco }}</h2>
    </div>

    <button mat-icon-button type="button" [attr.aria-label]="'common.buttons.close' | transloco" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-description">{{ 'ppwr.docProfiles.dialog.description' | transloco }}</p>

    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'ppwr.docProfiles.dialog.nameLabel' | transloco }}</mat-label>
      <input matInput [formControl]="nameControl" />
      <mat-error *ngIf="nameControl.hasError('required')">{{ 'ppwr.docProfiles.dialog.nameRequired' | transloco }}</mat-error>
      <mat-error *ngIf="nameControl.hasError('duplicateName')">{{ 'ppwr.docProfiles.dialog.nameDuplicate' | transloco }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'ppwr.evidenceFilterLabel' | transloco }}</mat-label>
      <mat-select [formControl]="evidenceTypeControl" multiple>
        <mat-option *ngFor="let evidenceType of data.evidenceTypes" [value]="evidenceType.id">{{ evidenceType.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="field-search-row">
      <mat-form-field appearance="outline" class="field-search" subscriptSizing="dynamic">
        <mat-label>{{ 'ppwr.docProfiles.dialog.fieldSearchLabel' | transloco }}</mat-label>
        <input matInput [formControl]="searchControl" [placeholder]="'ppwr.docProfiles.dialog.fieldSearchPlaceholder' | transloco" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <ng-container *ngIf="mergedFields.length; else noCustomFields">
      <mat-expansion-panel
        *ngFor="let section of sections"
        [expanded]="isSectionExpanded(section)"
        (opened)="onSectionExpandedChange(section, true)"
        (closed)="onSectionExpandedChange(section, false)">
        <mat-expansion-panel-header>
          <span [innerHTML]="('ppwr.docProfiles.dialog.sectionLabel' + section) | transloco"></span>
        </mat-expansion-panel-header>
        <table class="custom-field-table">
          <tr>
            <th>{{ 'ppwr.docProfiles.dialog.columnCustomField' | transloco }}</th>
            <th>{{ 'ppwr.docProfiles.dialog.systemTab' | transloco }}</th>
            <th>{{ 'ppwr.docProfiles.dialog.unitTab' | transloco }}</th>
            <th>
              <button mat-button type="button" color="primary" class="filter-button" (click)="toggleAllFields(section)">
                {{ (areAllFieldsSelected(section) ? 'common.buttons.selectNone' : 'common.buttons.selectAll') | transloco }}
              </button>
            </th>
          </tr>
          <tr *ngFor="let field of filteredFields()">
            <td>{{ field.name }}</td>
            <td>
              <mat-icon *ngIf="field.systemId != null" class="field-present">check</mat-icon>
              <mat-icon *ngIf="field.systemId == null" class="field-absent">close</mat-icon>
            </td>
            <td>
              <mat-icon *ngIf="field.unitId != null" class="field-present">check</mat-icon>
              <mat-icon *ngIf="field.unitId == null" class="field-absent">close</mat-icon>
            </td>
            <td>
              <mat-checkbox [checked]="isFieldSelected(section, field)" (change)="toggleField(section, field)"></mat-checkbox>
            </td>
          </tr>
        </table>
      </mat-expansion-panel>
    </ng-container>
    <ng-template #noCustomFields>
      <p class="empty-text">{{ 'ppwr.docProfiles.dialog.noCustomFields' | transloco }}</p>
    </ng-template>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button type="button" (click)="closeDialog()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="save()">
      {{ 'common.buttons.save' | transloco }}
    </button>
  </mat-dialog-actions>
</div>
